"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-h1", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M.5 2.4C.5 1.352 1.354.5 2.4.5h23.2c1.047 0 1.9.854 1.9 1.9v23.2c0 1.047-.854 1.9-1.9 1.9H2.4c-1.047 0-1.9-.854-1.9-1.9V2.4z", stroke: "#BBB" }),
            _react2.default.createElement("path", { d: "M13.117 16.57c0 .755-.384.896-1.216.922v.615h4.057v-.615c-.857-.026-1.216-.167-1.216-.922v-5.93c0-.743.359-.884 1.216-.91v-.615h-4.057v.615c.832.026 1.216.167 1.216.91v2.51H8.842v-2.51c0-.743.384-.884 1.216-.91v-.615H6v.615c.858.026 1.216.167 1.216.91v5.93c0 .755-.358.896-1.216.922v.615h4.058v-.615c-.832-.026-1.216-.167-1.216-.922v-2.728h4.275v2.728zM19.76 9c-.666.884-1.216 1.217-2.458 1.396l-.41.064v.525h1.69v5.572c0 .781-.307.832-1.69.922v.628h4.89v-.628c-1.33-.077-1.612-.14-1.612-.922V9h-.41z", fill: "#4C4C4C" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-h1.js
// module id = 1882
// module chunks = 0